import * as Sentry from "@sentry/react";
import { useCallback, useEffect, useState } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
// libraries
import { useNavigate } from "react-router-dom";

import { ampli } from "../../ampli";
// libraries
import PaymentModal from "../../components/payment/paymentDialog";
import Result from "../../components/payment/paymentMethods/result";
import { getContractDetails } from "../../setup/api/services/contract";
import {
  ESenderRole,
  IContractDetailsResponseData,
} from "../../setup/api/services/contract/models";
import { doAction } from "../../setup/api/services/contractActions";
import { EContractActions } from "../../setup/api/services/contractActions/enum";
import { IContractActionRequestBody } from "../../setup/api/services/contractActions/models";
import { checkPaymentStatus } from "../../setup/api/services/payment";
import { PaymentBrand } from "../../setup/api/services/payment/models";
import { AuthConfig } from "../../setup/context/config/authConfig";

export enum MessageType {
  NONE = "NONE",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}
let hack = false;
const Payment = () => {
  const [open, setOpen] = useState(false);
  const [messageType, setMessageType] = useState<MessageType>(MessageType.NONE);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const paymentBrand = searchParams.get("paymentBrand");
  const contractId = searchParams.get("contractId");
  const userId = AuthConfig.getUserInfo().id;
  const handleClose = useCallback(() => setOpen(false), []);
  const getActorType = (contract: IContractDetailsResponseData) => {
    if (contract.senderId == userId) return ESenderRole.PROVIDER;
    else return ESenderRole.CUSTOMER;
  };

  const { t } = useTranslation();

  const buyerFundAction = async (contractId: string, checkoutId: string) => {
    const response = await getContractDetails(contractId);
    const contract = response.data;
    const body: IContractActionRequestBody = {
      contractId: contract.id,
      userId: userId,
      actorRole: getActorType(contract),
      receiverId: contract?.receiverId || userId,
      senderId: contract.senderId,
      contractAction: EContractActions.CUSTOMER_FUND,
      transactionId: checkoutId,
    };
    const dataForAmpli = {
      amount: contract?.itemPrice + contract?.shipment!.fee,
      paymentBrand: paymentBrand,
      shortId: contract.shortId,
    };
    doContractAction(body, dataForAmpli);
  };
  const sendAmpliEventPayedContract = (dataForAmpli) => {
    ampli.payedContract({
      paymentAmount: dataForAmpli.amount,
      userRole: "buyer",
      paymentMethod:
        (dataForAmpli.paymentBrand == PaymentBrand.MADA && "DC") ||
        (dataForAmpli.paymentBrand == PaymentBrand.VISA && "CD") ||
        (dataForAmpli.paymentBrand == PaymentBrand.APPLEPAY && "applePay") ||
        "DC",
      paymentDate: new Date().toISOString(),
      contractId: dataForAmpli.shortId,
    });
  };
  const doContractAction = (body: IContractActionRequestBody, dataForAmpli) => {
    doAction(body)
      .then((res) => {
        if (res.sent === true) {
          sendAmpliEventPayedContract(dataForAmpli);
          console.log(t("lbl_action_under_processing"), "success");
        } else {
          console.log(t("lbl_cannot_make_this_call"), "error");
        }
      })
      .catch(() => {
        console.log(t("lbl_cannot_make_this_call"), "error");
      });
  };
  const checkStatus = async (id: string) => {
    try {
      const result = await checkPaymentStatus(id);
      setOpen(true);
      if (result?.data?.status === "SUCCESS") {
        if (contractId && id) await buyerFundAction(contractId, id);
        setMessageType(MessageType.SUCCESS);
      } else {
        setMessageType(MessageType.ERROR);
      }
    } catch (error) {
      Sentry.captureException(error);
      setOpen(true);
      setMessageType(MessageType.ERROR);
    }
    setTimeout(() => {
      navigate(-1);
    }, 5000);
  };

  useEffect(() => {
    if (id && !hack) {
      hack = true;
      checkStatus(id);
    }
  }, [id, searchParams]);

  const handleForm = useCallback(() => {
    if (messageType === MessageType.SUCCESS) handleClose();
    else {
      setMessageType(MessageType.NONE);
      navigate(-1);
    }
  }, [handleClose, messageType, navigate]);

  return (
    <PaymentModal open={open} handleClose={handleClose}>
      <Result messageType={messageType} handleSubmit={handleForm} />
    </PaymentModal>
  );
};

export default Payment;
